import { Component, Inject, Input } from '@angular/core';
import { Constant } from '../../../../constants/constant';
import { environment } from '../../../../environments/environment';
import { ProductService } from '../../../services/product.service';
import { Router } from '@angular/router';
import { ContactService } from '../../../services/contact.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DynamicFormComponent } from '../../../shared/component/dynamic-form/dynamic-form.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { downloads } from '../../../util/calsoft.validators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'calsoft-form-popup',
  imports: [MatDialogTitle, NgIf, MatProgressSpinnerModule, DefaultLayoutDirective, MatCheckboxModule, CustomFlexLayoutModule, DefaultLayoutAlignDirective, MatIconButton, MatIcon, CdkScrollable, MatDialogContent, DefaultStyleDirective, DefaultFlexDirective, DynamicFormComponent],
  templateUrl: './form-popup.component.html',
  styleUrl: './form-popup.component.scss'
})
export class FormPopupComponent {



  data: any;

  text!: string;

  regConfig: any[] = [];

  @Input() input: any;

  @Input() item: any;

  popupForm: any;
  popupText: any;
  action: any;
  popupType: any;


  constructor(private dialogRef: MatDialogRef<FormPopupComponent>,
    public snackBar: MatSnackBar,
    private contactService: ContactService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) data : any,
    private productService: ProductService,
  ) {

    this.data = data;

  }

  init: boolean = false;

  formId: any;

  formTitle: any;

  fileName: any = undefined;

  serverPath = environment.serverAPI2 + "/api/core/download/pdf?filename=/gallery/";

  isLoading: boolean = true;
  ngOnInit() {


    console.log("this.data", this.data);

    this.formId = this.data.formId;

    this.formTitle = this.data.title;

    this.fileName = this.data.fileName;
    this.popupType = this.data.type;


    this.action = this.data.action;
    let datas = this.data.regConfigdata;
    if(datas){
       this.regConfig= this.data.regConfigdata;
       console.log("the datas is ",this.regConfig);
       
       this.init = true;
    }
    if(this.formId!=null){
      this.createDynamicForm(this.formId);
    }

    if (this.data.action === 'download') {

    } else if (this.data.action === 'form') {

    }

    this.text = 'Submit';
    if (this.regConfig?.length) {
      this.isLoading = false;
    } else {

      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
    }

  }



  createDynamicForm(formGroupId : any) {
    this.contactService.getDynmaicForm(formGroupId).subscribe((data) => {
      let value: any = data
      this.regConfig = value;
      this.init = true;
    });
  }


  close() {
    this.dialogRef.close({ event: 'close' })
  }


  submit(value: any) {

    let filteredList = this.regConfig
      .filter(item => item.inputType.toLowerCase().includes('button'))
      .map(item => ({ label: item.label }));

    filteredList.forEach(label => {
      if (value.hasOwnProperty(label.label)) {
        delete value[label.label];
      }
    });

    let filteredListFile = this.regConfig
      .filter(item => item.inputType.toLowerCase().includes('file'))
      .map(item => ({ label: item.name }));

    filteredListFile.forEach(label => {
      if (value.hasOwnProperty(label.label)) {
        const newKey = label.label + '_file';
        value[newKey] = value[label.label];
        delete value[label.label];
      }
    });

    let object : any = {};
    let keysToCheck = ["phoneNumber", "email", "name"];
    let keysList = keysToCheck.filter(key => value.hasOwnProperty(key));
    keysList.forEach(key => {
      object[key] = value[key];
    });

    object['formGroupId'] = this.data['formId'];
    object['value'] = JSON.stringify(value);
    this.saveForm(object);

  }


  downloadPdf() {
    if (this.fileName != undefined) {
      let smallImage = "/gallery/" + this.fileName;
      this.productService.downloadPdf(smallImage).subscribe(
        data => {
          downloads(data, this.fileName);
        },
      )
    }
  }

  saveForm(object : any) {
    if (this.text == 'Submit') {
      this.contactService.saveForm(object).subscribe(
        (response : any) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Submit";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            if (this.action == "download") {
              if (this.fileName != null) {
                this.downloadPdf();
              }
            }

            this.close();
            if (this.action != "download" && this.action != "form") {
              if (this.fileName == null) {
                   const navPath = localStorage.getItem("formNavigation");
            if (navPath) {
              this.router.navigate([navPath]);
              localStorage.removeItem("formNavigation");
            }
            else {
              this.router.navigate(['']);
            }
              }
            }

          }
          else {
            this.text = "Submit";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        () => { this.text = "Submit" });
    }
    else {

    }
  }



}
